<template lang="pug">
v-menu(
  offset-y
)
  template(#activator="{ on }")
    v-text-field(
      v-model="name"
      label="Название категории"
      dense
      outlined
      hide-details
      v-on="on"
      @focus="focusHandler"
      v-debounce="findCategories"
    )
  v-list
    template(v-if="results.loading || !results.all")
      .text-center
        v-progress-circular(
          indeterminate
          color="primary"
        )
    template(v-else-if="results.all.length && !results.loading")
      v-list-item(
        v-for="category in results.all"
        :key="category.id"
        @click="clickCategoryHandler(category)"
      ) {{ category.name }}
    v-list-item(
      v-else-if="!results.all.length && name"
    ) Ничего не найдено
    v-list-item(
      v-else
    ) Начните вводить название
</template>

<script>
import eventPublicService from '@/services/API/event/_public';

export default {
  name: 'SearchCategoriesField',

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },

  data() {
    return {
      name: '',
      results: {
        all: null,
        loading: false,
      },

      menu: false,
    };
  },

  watch: {
    value(v) {
      this.name = this.results.all?.find(({ id }) => id === v)?.name || '';
    },
  },

  methods: {
    async findCategories() {
      this.results.loading = true;
      const params = {
        'search[name]': this.name || null,
        'per-page': 5,
        fields: 'id,name',
        sort: '-id',
      };

      const response = await eventPublicService.getSearchEventCategories(params);

      this.results.all = response.data.data;
      this.results.loading = false;
    },

    focusHandler() {
      if (!this.results.all) {
        this.findCategories();
      }
    },

    clickCategoryHandler({ name, id }) {
      this.name = name;
      this.$emit('input', id);
    },
  },
};
</script>
